import { Column, FilterFnOption, RowData } from "@tanstack/react-table";

import { type ConfigurationViewConfig } from "./datatable-configuration-view/datatable-configuration-view";
import { DatatableBody } from "./datatable-body";
import { type DatatableColumn, type DatatableState, TSectionData } from "./datatable-types";
import { DataTableContextProvider, useUnsafeDatatableContext } from "./use-datatable-context";

interface DatatableProps<TData extends RowData> {
  viewKey: string; // unique key for table view
  workspaceId: string;
  data: TData[];
  columns: DatatableColumn<TData>[];
  initialState?: DatatableState;
  debugTable?: boolean;
  synchToApi?: boolean;

  globalFilterFn?: FilterFnOption<TSectionData<TData>>;
  getColumnCanGlobalFilter?: (column: Column<TSectionData<TData>, unknown>) => boolean;

  config?: ConfigurationViewConfig;
}

export function Datatable<TData extends RowData>({ config, ...props }: DatatableProps<TData>) {
  const maybeDataTableContext = useUnsafeDatatableContext();

  if (!maybeDataTableContext) {
    return (
      <DataTableContextProvider<TData> {...props}>
        <DatatableBody<TData> config={config} />
      </DataTableContextProvider>
    );
  }

  return <DatatableBody<TData> config={config} />;
}
